import { ComboboxComponent } from "@/components/select/Combobox";
import { InputField } from "@/components/input-field/InputField";
import { SelectComponent } from "@/components/select/Select";
import { AuxEntity } from "@/services/aux-entities.service";
import { AppColors } from "@/styles/colors";
import { standardNamePatternOne } from "@/utils/reg-expressions";
import { Card, Field, Flex, Grid, GridItem } from "@chakra-ui/react";
import { Control, FieldErrors } from "react-hook-form";
import { ProductionGrainCreationForm } from "../create/schema/production-grain-creation.schema";

interface Props {
  control: Control<ProductionGrainCreationForm>;
  errors: FieldErrors<ProductionGrainCreationForm>;
  grains: AuxEntity[] | null;
  isActive: boolean;
  loading: boolean;
  loadingGrains: boolean;
  comboboxKey: string;
}

export const ProductionGrainForm = ({
  control,
  errors,
  grains,
  isActive,
  loading,
  loadingGrains,
  comboboxKey,
}: Props) => {
  return (
    <Flex flexDir="column" gap="24px" marginTop="30px">
      <Card.Root maxW="full" borderRadius="8px">
        <Card.Body
          paddingX="32px"
          paddingY="30px"
          borderRadius="8px"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
        >
          <Grid templateColumns="repeat(4, 1fr)" gap={6}>
            <GridItem>
              <InputField
                inputName="nombre"
                labelText="Nombre"
                placeholder="Ingresar"
                control={control as any}
                disabled={loading || !isActive}
                allowedPattern={standardNamePatternOne}
                required
                minHeight="40px"
              />
            </GridItem>

            <GridItem>
              <Field.Root invalid={!!errors?.aplicaPPMB}>
                <SelectComponent
                  name="aplicaPPMB"
                  items={[
                    { label: "Sí", value: true },
                    { label: "No", value: false },
                  ]}
                  labelText="Aplica a PP y MB"
                  placeholder="Seleccionar"
                  control={control as any}
                  disabled={loading || !isActive}
                  minHeight="40px"
                  required
                />
                <Field.ErrorText>
                  {String(errors?.aplicaPPMB?.message ?? "")}
                </Field.ErrorText>
              </Field.Root>
            </GridItem>

            <GridItem>
              <Field.Root invalid={!!errors?.granoAdmis}>
                <Field.Label>Grano Admis</Field.Label>
                <ComboboxComponent
                  key={comboboxKey}
                  items={
                    grains?.map((el) => ({
                      label: el.nombre,
                      value: String(el.id),
                    })) || []
                  }
                  menuMaxHeight="250px"
                  name="granoAdmis"
                  control={control as any}
                  clearable
                  placeholder="Seleccionar grano"
                  fullWidth
                  loading={loading || loadingGrains}
                  disabled={loading || loadingGrains || !isActive}
                  minHeight="40px"
                />
                <Field.ErrorText>
                  {String(errors?.granoAdmis?.message ?? "")}
                </Field.ErrorText>
              </Field.Root>
            </GridItem>

            <GridItem>
              <Field.Root invalid={!!errors?.sumaHA}>
                <SelectComponent
                  name="sumaHA"
                  items={[
                    { label: "Sí", value: true },
                    { label: "No", value: false },
                  ]}
                  labelText="Suma HA"
                  placeholder="Seleccionar"
                  control={control as any}
                  disabled={loading || !isActive}
                  minHeight="40px"
                  required
                />
                <Field.ErrorText>
                  {String(errors?.sumaHA?.message ?? "")}
                </Field.ErrorText>
              </Field.Root>
            </GridItem>
          </Grid>
        </Card.Body>
      </Card.Root>
    </Flex>
  );
};
